import React, { Suspense, useContext } from 'react';
import loadable from '@loadable/component';
import { Router, RouteComponentProps } from '@reach/router';
import { useClient } from 'urql';

import { Loader } from '@quotient/riq-react-ui';
import { getUrlParameter } from '@quotient/riq-helpers';
import { AppContext } from '@quotient/riq-state';
import Header from './static/header';
import Footer from './static/footer';

import Carrier from './Components/Carrier';
import Page from './Components/Page';

import './static/static.scss';

const Gallery = loadable(() => import(/* webpackPrefetch: true */ './containers/Gallery/Gallery'), {
  fallback: <Loader />
});

const SearchResult = loadable(() => import(/* webpackPrefetch: true */ './containers/Search/SearchResult'), {
  fallback: <Loader />
});

const getCommonDataQuery = `query {
  getCommonData {
    shoppingList { url }
    CI_SigninSignupLinks { isUserLoggedIn signinlink signuplink firstName }
    categoryList {
      moreArr { name count url active }
      categoryExtend
    }
    offcanvasShoppingList {
      listItems {
        totalRecords showListIdentifier sortable sortfilter_data { headingText sortFilters{ name id source } } sortfilter listId arrItems {
          itemId itemName parent itemQuantity customAttributes { crossout source }
          offer { omsCid offerId offerCode brandName companyName offerSummary offerDescription offerValue offerDisclaimer offerSource offerGS1 manufacturerCode manufacturerId discountType fogFeature hasExtendedRequirements isContinuity isDailyDealOffer isEmployeeOffer isExclusiveOffer isManufactory redeemed activated offerActiveDate offerUpdateDate offerShutoffDate offerExpiryDate offerExpiryDateFormatted redemptionDate offerImage smallImage mediumImage largeImage }
        }
      }
      listId
      listIdentifier
    }
    recaptcha { publicKey { v3 } }
  }
}`;

const Routes: React.FC<RouteComponentProps> = function Routes(params) {
  const isHeaderLess = getUrlParameter('headerless') === 'true' ? true : false;
  const { setAppState }: any = useContext(AppContext);
  const carrierRef = React.useRef<HTMLElement>(null);
  const client = useClient();

  React.useEffect(() => {
    client
      .query(getCommonDataQuery)
      .toPromise()
      .then(({ data: { getCommonData = null } = {} }) => {
        if (getCommonData) {
          setAppState({ getCommonData });
        }
      });
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <Header />
      <Carrier ref={carrierRef} />
      <Router basepath="/">
        <Page path="/">
          <Gallery path="/coupon" />
          <SearchResult path="/search" />
        </Page>
      </Router>
      <Footer />
    </Suspense>
  );
};

export default Routes;
